

const _MS_PER_DAY = 1000 * 60 * 60 * 24

// a and b are javascript Date objects
export function diffDays(first, second) {
  if (!(first && second)) {
    return undefined
  }

  // Discard the time and time-zone information.
  const utc1 = Date.UTC(first.getFullYear(), first.getMonth(), first.getDate())
  const utc2 = Date.UTC(second.getFullYear(), second.getMonth(), second.getDate())

  return Math.floor((utc2 - utc1) / _MS_PER_DAY)
}

export function addDays(date, days) {
  if (!(days && date)) {
    return undefined
  }

  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}